import { quiz as library_quiz } from 'feed';
import ProcessingQuizEvent from '~/actions/quiz/ProcessingQuizEvent';
import { QUIZ_CONSTANTS } from '~/actions/quiz/constants';
import { hasQuizInLocalStorage, saveEventShowQuizToLocalStorage } from '~/actions/quiz/displayController';
import { IQuiz, IQuizList } from '~/actions/quiz/types';
import RestServices from '~/api';
import { getFromSessionStorage, saveToSessionStorage } from '~/helpers/storage';
import { clickstreamLogger } from '~/logging';
import { getCurrentPlatformType } from '~/utils/getCurrentPlatformType';
import { setInactivityTimeOut } from '~/utils/setInactivityTimeOut';

/**
 * Проверяет соответствие адреса страницы паттерну квиза
 * @param urlPatterns
 * @returns
 */
const isUrlPatternSame = (urlPatterns: string[] = [], quizId: string): boolean => {
  if (!urlPatterns.length) {
    clickstreamLogger.warn(`Quiz: ${quizId} - display parameters are not set: urlPatterns`);

    return false;
  }
  const test = urlPatterns.map((pattern: string) => {
    return pattern?.startsWith('{{') && pattern?.endsWith('}}')
      ? new RegExp(pattern.substring(2, pattern.length - 2)).test(
        location.href.replace(/\/$/, '')
      )
      : false;
  }).some(result => result);
  if (!test) {
    clickstreamLogger.warn(`Quiz: ${quizId} - the current page does not match the parameter urlPatterns`);
  }

  return test;
};

/**
 * Стартует квиз и записывает показ в localStorage
 * @param quizId - идентификатор квиза
 * @param fnQuizStart - функция старта
 * @param fnTestQuiz - функция проверки отрисовки квиза
 */
const showQuiz = (
  quizId: string,
  fnQuizStart: () => void,
  fnTestQuiz: () => boolean
) => {
  fnQuizStart();
  if (fnTestQuiz()) {
    saveEventShowQuizToLocalStorage(quizId);
  }
};

/**
 * Активация квизов
 */
const activeQuiz = () => {
  const isMobileDevice = getCurrentPlatformType() === 'mobile';
  const quizzes = getQuizzes();
  if (quizzes.length) {
    quizzes.forEach((quiz) => {
      if (isUrlPatternSame(quiz.triggerData.urlPatterns, quiz.uuid)) {
        const Quiz = new library_quiz.QuizCreator(
          quiz.uuid,
          quiz.steps,
          quiz.configuration,
          isMobileDevice
        );
        Quiz.quizStyle.addStyles();
        const ProcessingQuizEventClass = new ProcessingQuizEvent();
        Quiz.callbackFunction = ProcessingQuizEventClass.processingEvent;
        if (!hasQuizInLocalStorage(quiz.uuid)) {
          // TODO CSA-6264 https://jira.sberbank.ru/browse/CSA-6264
          // вернуть механизм inactivityTimeout, когда механизм будет реализован
          // на бэке и в ЛК
          // const timeoutFunction = quiz.triggerData.isInactivityTime
          //   ? setInactivityTimeOut
          //   : setTimeout;
          const timeoutFunction = setTimeout;

          timeoutFunction(showQuiz, quiz.triggerData.startTime * 1000, quiz.uuid, Quiz.start, Quiz.hasQuizInPage);
        }
      }
    });
  }
};

/**
 * Получает список квизов из SessionStorage
 * @returns
 */
export const getQuizzes = (): IQuiz[] => {
  const quizzes: IQuizList = JSON.parse(
    JSON.stringify(getFromSessionStorage(QUIZ_CONSTANTS.KEY_QUIZ_SESSION_STORAGE, 'quizList'))
  );
  if (quizzes) return quizzes.payload;

  return [];
};

/**
 * Получает список квизов и записывает данные в SessionStorage
 * Активирует квизы, если данные есть
 */
export const setQuizList = (): void => {
  RestServices.quizMethod.get().then((result: IQuizList) => {
    saveToSessionStorage(QUIZ_CONSTANTS.KEY_QUIZ_SESSION_STORAGE, 'quizList', result);
    if (result.payload.length > 0) {
      activeQuiz();
    }
  });
};

/**
 * Инициализирует квизы при загрузке страницы
 * Проверяет данные в SessionStorage,
 * Если данных нет - получает список квизов,
 * Если данные есть - активирует квизы
 */
export const initQuiz = (): void => {
  if (getFromSessionStorage(QUIZ_CONSTANTS.KEY_QUIZ_SESSION_STORAGE, 'quizList')) {
    if (getQuizzes().length > 0) {
      activeQuiz();
    }

    return;
  }
  setQuizList();
};
